import { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";

interface MonthDropdownProps {
  onChange: (month: string, rawKey?: string) => void; // returns MM-YYYY, rawKey
}

export default function MonthDropdown({ onChange }: MonthDropdownProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState<[string, string][]>([]);
  const [selectedKey, setSelectedKey] = useState<string>("");

  const toggle = () => setDropdownOpen((prev) => !prev);

  const formatSelectedKey = (key: string) => {
    const part = key.split("|")[0];
    const year = part.slice(0, 4);
    const month = part.slice(5, 7);
    return `${month}-${year}`; // "06-2025"
  };

  useEffect(() => {
    const fetchMonths = async () => {
      const serverUrl = localStorage.getItem("serverUrl");
      const APP_TOKEN = localStorage.getItem("appToken");

      if (!serverUrl || !APP_TOKEN) return;

      const url = `${serverUrl}${API.getAllowedMonths}`;
      try {
        const { status, data } = await getData(url, true);
        if (status === 200 && Array.isArray(data?.data) && data.data.length > 0) {
          const entries = data.data.flatMap((obj: Record<string, string>) =>
            Object.entries(obj)
          ) as [string, string][];
          setDropdownOptions(entries);
          if (entries.length > 0) {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
            const currentMatch = entries.find(([k]) => k.startsWith(`${currentYear}-${currentMonth}`));
            const initialEntry = currentMatch || entries[0];
            const [firstKey] = initialEntry;
            setSelectedKey(firstKey);
            onChange(formatSelectedKey(firstKey), firstKey); // pass initial value and raw key
          }
        }
      } catch (err) {
        console.error("❌ Failed to fetch months:", err);
      }
    };

    fetchMonths();
  }, []);

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    onChange(formatSelectedKey(key), key);
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary">
        {dropdownOptions.find(([key]) => key === selectedKey)?.[1] || "Select Month"}
      </DropdownToggle>
      <DropdownMenu style={{ maxHeight: "300px", overflowY: "auto" }}>
        {dropdownOptions.map(([key, label]) => (
          <DropdownItem key={key} onClick={() => handleSelect(key)}>
            {label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
